import { Link, useNavigate } from "react-router-dom"
import footer_logo from "../../assets/img/footer_logo.svg"
// Define prop types (Optional but good practice)
import PropTypes from "prop-types"; // Optional for prop validation
import logo from "../../assets/img/logo-w.png";

export const PatientFooter = ({is_relative}) => {
    const navigate = useNavigate();
    const handleLogoClick = () =>{
        navigate("/");
      }
    return (
        <>
            <footer className={`site_footer ${is_relative ? "relative" : ""}`}>
                <div class="bottom_part pt-0 mt-0" style={{borderTop: "0"}}>
                
                    <div class="site_container text-center">
                        <img onClick={handleLogoClick} style={{cursor: "pointer",width: "220px"}} src={logo} alt="" class="mb-4"/>
                        <div class="site_row">
                            <p>© {new Date().getFullYear()}. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

PatientFooter.propTypes = {
    is_relative: PropTypes.bool, // Ensures it's a boolean
};

// Default props (Optional)
PatientFooter.defaultProps = {
    is_relative: false, // Default to false if not provided
};